const generalES = {
    "modalConfirm": {
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        }
    },
    "tableDropdown": {
        "action": "Acción",
        "edit": "Editar",
        "delete": "Eliminar",
        "viewDetails": "Ver Detalles",
        "copyMLId": "Copiar ID ML",
        "viewStats": "Ver Estadísticas"
    },
    "tableModal": {
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "edit": "Editar"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        }
    },
    "select": {
        "placeholder": "Seleccionar..."
    },
    "asyncDropdown": {
        "placeholder": "Buscar...",
        "loading": "Cargando...",
        "noResults": "No hay opciones",
        "blacklisted": "En la lista negra"
    },
    "table": {
        "noDataAvailable": "No hay datos disponibles"
    },
    "tableHelper": {
        "loading": "Cargando...",
        "error": "Ocurrió un error",
        "noData": "No hay datos disponibles"
    },
    "countriesSelect": {
        "placeholder": "Buscar país..."
    },
    "consentModal": {
        "header": "Consentimiento Requerido",
        "body": {
            "description": "Por favor revise y acepte nuestros nuevos términos de consentimiento para continuar usando nuestros servicios.",
            "label": {
                "firstName": "Nombre",
                "lastName": "Apellido",
                "email": "Correo Electrónico",
                "termsOfUsageAgreement": "Estoy de acuerdo con los <1>Términos de Uso</1>",
                "privacyPolicyAgreement": "Estoy de acuerdo con la <1>Política de Privacidad</1>",
                "cookiePolicyAgreement": "Estoy de acuerdo con la <1>Política de Cookies</1>"
            }
        },
        "button": {
            "submit": "Enviar"
        }
    },
    "passwordResetModal": {
        "header": "Cambia Tu Contraseña",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Contraseña actual",
                    "newPassword": "Nueva contraseña",
                    "repeatNewPassword": "Repetir nueva contraseña"
                },
                "button": {
                    "submit": "Enviar"
                },
                "message": {
                    "currentPasswordRequired": "Se requiere tu contraseña antigua",
                    "newPasswordRequired": "Se requiere una nueva contraseña",
                    "newPasswordMinLength": "Tu contraseña debe tener al menos 10 caracteres",
                    "newPasswordDifferentFromOld": "La nueva contraseña debe ser diferente de la antigua",
                    "newPasswordConfirmation": "La nueva contraseña debe coincidir"
                }
            }
        },
        "footer": {
            "note": "<strong>Nota: </strong>Ha pasado un tiempo desde que actualizaste tu contraseña por última vez. Por tu seguridad, por favor restablece tu contraseña."
        },
        "message": {
            "success": "¡Tu contraseña ha sido cambiada!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e intenta de nuevo."
        },
        "modal": {
            "confirm": {
                "header": "¿Estás seguro de que deseas cambiar tu contraseña?",
                "body": "Por favor confirma"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "Comentarios de QC"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Sub-Usuario: "
        },
        "placeholder": {
            "subUser": "Seleccionar Sub-Usuario"
        },
        "button": {
            "reset": "Restablecer"
        }
    },
    "footer": {
        "label": {
            "copyright": "Derechos de Autor © {{year}}",
            "allRightsReserved": "Todos los derechos reservados.",
            "privacyPolicy": "Política de Privacidad",
            "termsAndConditions": "Términos y Condiciones"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Oferta Exclusiva para",
        "off": "OFF",
        "promoCode": "Código Promocional",
        "expiresIn": "Vence en",
        "clickHereToAvailThisOffer": "Haga clic aquí para aprovechar esta oferta",
        "availableOnAllSubscriptionPlans": "Disponible en todos los planes de suscripción."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Oferta Exclusiva para",
        "off": "OFF",
        "limitedTimePromoOffer": "Este Código Promocional Temporal ha sido creado exclusivamente para ti. ¡No te lo pierdas!",
        "promoCode": "Tu Código Promocional",
        "expiresIn": "Vence en",
        "days": "Días",
        "hours": "Horas",
        "minutes": "Minutos",
        "seconds": "Segundos",
        "availableOnAllSubscriptionPlans": "Esta oferta exclusiva está disponible en todos los planes de suscripción."
    }
};

export default generalES;